import { render, staticRenderFns } from "./servicescard.vue?vue&type=template&id=67fa5bbc&"
import script from "./servicescard.vue?vue&type=script&lang=js&"
export * from "./servicescard.vue?vue&type=script&lang=js&"
import style0 from "./servicescard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports